import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const PositionedFeedbackForm = styled.div.withConfig({
  displayName: "EPSurveyWrapper__PositionedFeedbackForm",
  componentId: "gekf6o-0"
})(["position:fixed;bottom:17px;left:0;width:", ";z-index:900;"], props => props.width ? `${props.width}px` : '374px');
export const EPSurveyWrapper = ({
  children,
  width
}) => {
  return /*#__PURE__*/_jsx(PositionedFeedbackForm, {
    width: width,
    children: children
  });
};